import { connect } from "react-redux";
import CaseListingV2 from "./ListV2";
import { bindActionCreators } from "redux";
import {caseListRequest} from "../../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    caseListResponse : state.Dealer.caseListResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        caseListRequest,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CaseListingV2);